export default {
      id: "icon--clock-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--clock-usage",
      toString: function () {
        return this.url;
      }
    }